import React, { useState } from 'react';
import Context from './Context';
import content from 'Content/content.json';
import { language, LANG_JP } from 'Root/constants';
import { isIFRAMEUrl } from 'Root/utils';

const {
  data: {
    productInfo: { [language]: lenses },
  },
} = content;
const isIframeState = isIFRAMEUrl();

const initialState = {
  isAuth: false,
  isIframe: isIframeState,
  floatButtonURL: "",
  InstagramBackgroundURL: "",
  product: 0,
  lensGuid: 'BCC-21606_20200504_EC_01_05_01',
  look: -1,
  makeup: 0,
  looksLoaded: false,
  ignoreRecommendation: false,
  lensCleared: false,
  looksCleared: false,
  makeupCleared: false,
  forceMakeupReset: false,
  forceLookReset: false,
  productId: 0,
  productChoose: {
    guid: '',
    type: '',
    index: 0,
  },
  recommendation: {
    active: -1,
    other: -1,
  },
  selectedShadesSet: {},
  isLensChanged: false,
  lensKey: 'rchic',
};
const ContextContainer = (props) => {
  const [state, setState] = useState(initialState);

  const login = () => {
    // setting timeout to mimic an async login
    setTimeout(
      () =>
        setState((prevState) => ({
          ...prevState,
          isAuth: true,
        })),
      200
    );
  };

  const updateProductChoose = (guid, type, index) => {
    setState((prevState) => ({
      ...prevState,
      productChoose: {
        guid,
        type,
        index
      }
    }));
  }

  const updateFloatButtonURL = (url) => {
    setState((prevState) => ({
      ...prevState,
      floatButtonURL: url
    }));
  }

  const updateInstagramBackgroundURL = (url) => {
    setState((prevState) => ({
      ...prevState,
      InstagramBackgroundURL: url
    }));
  }

  const updateIFrame = (iframe) => {
    setState((prevState) => ({
      ...prevState,
      isIframe: iframe
    }));
  }

  const logout = () => {
    localStorage.removeItem('loggedIn');
    setState((prevState) => ({
      ...prevState,
      isAuth: false,
    }));
  };

  const updateProduct = (product, pId) => {
    setState((prevState) => ({
      ...prevState,
      product,
      productId: pId,
      isLensChanged: true,
      makeup: language === LANG_JP ? 0 : prevState.makeup,
    }));
  };

  const updateLensGuid = (guid, key) => {
    setState((prevState) => ({
      ...prevState,
      lensGuid: guid,
      lensKey: key,
    }));
  };

  const updateLook = (look) => {
    setState((prevState) => ({
      ...prevState,
      look,
    }));
  };

  const updateMakeup = (makeup) => {
    setState((prevState) => ({
      ...prevState,
      makeup,
    }));
  };

  const updateLooksLoaded = () => {
    if (!state.looksLoaded) {
      setState((prevState) => ({
        ...prevState,
        looksLoaded: !prevState.looksLoaded,
      }));
    }
  };

  const updateIgnoreRecommendation = () => {
    if (!state.ignoreRecommendation) {
      setState((prevState) => ({
        ...prevState,
        ignoreRecommendation: !prevState.ignoreRecommendation,
      }));
    }
  };

  const updateClearLens = (value) => {
    setState((prevState) => ({
      ...prevState,
      lensCleared: value,
    }));
  };

  const updateClearLooks = (value) => {
    setState((prevState) => ({
      ...prevState,
      looksCleared: value,
    }));
  };

  const updateMakeupCleared = (value) => {
    setState((prevState) => ({
      ...prevState,
      makeupCleared: value,
    }));
  };

  const updateForceMakeupReset = (value) => {
    setState((prevState) => ({
      ...prevState,
      forceMakeupReset: value,
    }));
  };

  const updateForceLookReset = (value) => {
    setState((prevState) => ({
      ...prevState,
      forceLookReset: value,
    }));
  };

  const onVMInit = () => {
    setState((prevState) => ({
      ...prevState,
      makeup: 0,
      looksLoaded: false,
      ignoreRecommendation: false,
    }));
  };

  const updateRecommendation = (active, other) => {
    setState((prevState) => ({
      ...prevState,
      recommendation: {
        active,
        other,
      },
    }));
  };

  const updateSelectedShadesSet = (id, type) => {
    setState((prevState) => ({
      ...prevState,
      isLensChanged: false,
      selectedShadesSet: {
        ...prevState.selectedShadesSet,
        [type]: id,
      },
    }));
  };

  const clearState = (stateKey) => {
    setState((prevState) => ({
      ...prevState,
      [stateKey]: {},
    }));
  };

  const {
    productId,
    selectedShadesSet,
    isLensChanged,
    lensGuid,
    floatButtonURL,
    InstagramBackgroundURL,
    lensKey,
  } = state;
  return (
    <Context.Provider
      value={{
        isAuth: state.isAuth,
        isIframe: state.isIframe,
        login: login,
        logout: logout,
        product: state.product,
        productId,
        updateProduct: updateProduct,
        updateLensGuid: updateLensGuid,
        updateIFrame: updateIFrame,
        look: state.look,
        updateLook: updateLook,
        makeup: state.makeup,
        updateMakeup: updateMakeup,
        looksLoaded: state.looksLoaded,
        updateLooksLoaded: updateLooksLoaded,
        ignoreRecommendation: state.ignoreRecommendation,
        updateIgnoreRecommendation: updateIgnoreRecommendation,
        onVMInit: onVMInit,
        lensCleared: state.lensCleared,
        looksCleared: state.looksCleared,
        makeupCleared: state.makeupCleared,
        updateClearLens: updateClearLens,
        updateClearLooks: updateClearLooks,
        updateMakeupCleared: updateMakeupCleared,
        updateFloatButtonURL: updateFloatButtonURL,
        updateInstagramBackgroundURL: updateInstagramBackgroundURL,
        updateForceMakeupReset: updateForceMakeupReset,
        updateForceLookReset: updateForceLookReset,
        forceMakeupReset: state.forceMakeupReset,
        forceLookReset: state.forceLookReset,
        recommendation: state.recommendation,
        updateRecommendation: updateRecommendation,
        updateSelectedShadesSet,
        selectedShadesSet,
        clearState,
        isLensChanged,
        lensGuid,
        lensKey,
        floatButtonURL,
        InstagramBackgroundURL,
        productChoose: state.productChoose,
        updateProductChoose,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default ContextContainer;
